export default __webpack_public_path__ + "images/bgflt3.e9a0c3f.jpg";